import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-settings-2-icon',
  templateUrl: './general-settings-2.component.html'
})
export class GeneralSettings2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
